import React from "react"
import { Navigate, useLocation } from "react-router-dom"

import { resolvePreferredLocale } from "shared/lib/locale/contentLanguage"

export const LocaleRedirect = React.memo(() => {
  const { pathname, search } = useLocation()
  return (
    <Navigate replace to={`/${resolvePreferredLocale()}${pathname}${search}`} />
  )
})
